<template>
  <div class="container pb-5 mt-5" data-gtm-elem='age-gate'>
    <div class="text-center mx-auto">

      <!-- Step 1: Age Gate -->
      <form v-if="step === 1" @submit.prevent="submitAgeGate">
        <h2 class="mb-4">Enter Your Date of Birth to Continue</h2>

        <div class="mb-3 text-start col-md-6 mx-auto">
          <label class="form-label fw-bold">Date of Birth*</label>
          <div class="d-flex gap-2">
            <select v-model="dob.month" class="form-select" required>
              <option value="" disabled>Month</option>
              <option v-for="(m, i) in months" :key="i" :value="i + 1">{{ m }}</option>
            </select>
            <select v-model="dob.day" class="form-select" required>
              <option value="" disabled>Day</option>
              <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
            </select>
            <select v-model="dob.year" class="form-select" required>
              <option value="" disabled>Year</option>
              <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
            </select>
          </div>
        </div>

        <div v-if="errorMsg" class="text-danger ">
          {{ errorMsg }}
        </div>

        <button type="submit" class="btn-link mt-4">Submit</button>
      </form>

      <!-- Step 2: Fail Gate -->
      <div v-else-if="step === 2" class="text-center pb-5">
        <h2 class="mb-4">You Are Not Eligible To Participate In This Program</h2>
        <p class="mb-5">Please refer to the program <a href="https://snipp.us/!cuY0Z" target="_blank">Official Rules</a>
          for more details.</p>
      </div>
    </div>

    <div class="text-center mt-5 small px-md-5">
      <p>
        Jim Beam<sup>®</sup> encourages responsible drinking. Alcohol should be consumed in moderation. By
        entering this website, you are agreeing to our <a href="https://www.suntoryglobalspirits.com/terms-conditions"
          target="_blank">Terms&nbsp;and&nbsp;Conditions</a>, <a
          href="https://www.suntoryglobalspirits.com/privacy-policy" target="_blank">Privacy&nbsp;Policy</a>, and <a
          href="https://www.suntoryglobalspirits.com/cookie-policy" target="_blank">Cookie&nbsp;Policy</a>.
      </p>
    </div>
  </div>
</template>

<script>
import { differenceInYears } from 'date-fns';

export default {
  name: 'Gate',
  data() {
    return {
      step: 1,
      dob: {
        month: '',
        day: '',
        year: ''
      },
      errorMsg: '',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    };
  },
  computed: {
    years() {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let i = currentYear; i >= currentYear - 120; i--) {
        yearsArray.push(i);
      }
      return yearsArray;
    }
  },
  watch: {
    dob: {
      handler() {
        if (this.errorMsg === 'Please enter a valid date of birth.' || this.errorMsg === 'Please enter a complete Date of Birth.') {
          this.errorMsg = '';
        }
      },
      deep: true
    }
  },
  methods: {
    submitAgeGate() {
      this.errorMsg = '';

      const year = parseInt(this.dob.year, 10);
      const month = parseInt(this.dob.month, 10);
      const day = parseInt(this.dob.day, 10);

      // Check for empty or incomplete dates
      if (!year || !month || !day) {
        this.errorMsg = 'Please enter a complete Date of Birth.';
        return;
      }

      const birthDate = new Date(year, month - 1, day);

      // Validate strict calendar dates (prevents Feb 30, April 31, etc.)
      // JS Date auto-corrects overflow (e.g., Feb 30 -> Mar 2), so we check if the values shifted.
      if (
        birthDate.getFullYear() !== year ||
        birthDate.getMonth() !== month - 1 ||
        birthDate.getDate() !== day
      ) {
        this.errorMsg = 'Please enter a valid date of birth.';
        return;
      }

      const today = new Date();

      // Prevent future dates
      if (birthDate > today) {
        this.errorMsg = 'Please enter a valid date of birth.';
        return;
      }

      const age = differenceInYears(today, birthDate);

      const status = age < 21 ? 'fail' : 'pass';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'age_gate_submit',
        'status': status,
        'age_gate_age': age.toString()
      });

      if (age < 21) {
        this.step = 2;
        return;
      }

      // Validation passed
      sessionStorage.setItem('gatePassed', 'true');

      // Store standard Snipp values so they populate in Registration
      const formattedMonth = String(this.dob.month).padStart(2, '0');
      const formattedDay = String(this.dob.day).padStart(2, '0');
      const formattedDOB = `${this.dob.year}-${formattedMonth}-${formattedDay}`;
      sessionStorage.setItem('DateOfBirth', formattedDOB);

      this.$router.push({ name: 'Home' });
    }
  }
};
</script>

<style scoped>
.gate-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gate-content {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  width: 100%;
}
</style>
